export type PrintLabel = {
  devEui: string;
  sequenceNumber: string;
};

// Label printer runs on the office LAN, so this only resolves from that network.
export const LABEL_PRINTER_URL = 'http://amarilstraat20.local:8787';

export const buildLabelPrintUrl = (labels: PrintLabel[], createdBy: string, reference: string) => {

  const query = [
    `labels=${encodeURIComponent(JSON.stringify(labels))}`,
    `createdBy=${encodeURIComponent(createdBy)}`,
    `reference=${encodeURIComponent(reference)}`,
  ].join('&');

  return `${LABEL_PRINTER_URL}/load?${query}`;

};
